let _ = require('lodash');

const DEFAULT_ROOT_CLEANUP_EXCLUDES = [
    'layout',
    'user',
    'feedback',
    'header',
    'footer',
    'bitrix'
];

module.exports = {
    /**
     * Очистка состояние это базовое действие применяемое при навигации по приложению.
     * Приложение работает в 2х режимах, синхронная навигация по основным разделам с перезагрузкой страницы и
     * ассинхронная навигация по внутренним разделам приложения. Это действие позволяет пользователю очистить
     * состояние приложения от избыточных полей, при это сохраняя актуальные поля для всех страниц раздела.
     *
     * Важно понимать, что при переходе в другой раздел состояние будет обнулено из-за перезагрузки страницы.
     *
     * @param {Array} [additionalExcludeFields=[]] Поля, которые оставляем
     * @param {String} [node=[]] Узел, который чистим. По умолчанию - корень
     * @return {Function}
     */
    cleanup (additionalExcludeFields = [], node = []) {
        return function cleanup (args, state) {
            let exclude = _.isEmpty(node) ?
                [...DEFAULT_ROOT_CLEANUP_EXCLUDES, ...additionalExcludeFields] : additionalExcludeFields;

            let tree = state.get(node);

            _.each(tree, (value, key) => {
                if (!_.includes(exclude, key)) {
                    state.unset([...node, key]);
                }
            });
        };
    },

    /**
     * Устанавливаем текущий экран
     * @param {Object} args
     * @param {String} args.page
     * @param {Object} state
     */
    setCurrentPage ({ page }, state) {
        let layout = state.get('layout');

        /**
         * Если лейаут не установлен, ставим по дефолту base
         */
        if (!layout) {
            state.set('layout', 'main');
        }

        /**
         * В случае если все проверки пройдены, то мы успешно
         * устанавливаем нужное значение в state
         */
        state.set(['page', 'name'], page);
    }
};



// WEBPACK FOOTER //
// ./actions/page.js